"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedirectTiles = void 0;
const consts_1 = require("../../consts");
const TimecardTilesTypes_1 = require("./TimecardTilesTypes");
const react_1 = __importDefault(require("react"));
const Icons_1 = require("@amzn/atoz-web/Icons");
const View_1 = require("@amzn/atoz-web/View");
const utils_1 = require("../../utils");
const getRedirectTiles = ({ isReportAbsenceLatenessEnabled, isAttendanceIngressPointEnabled, isTaskListForNativeEnabled, isTaskListForWebEnabled, isPunchWorkflowForWebEnabled, isPunchWorkflowForNativeEnabled, isReportTravelTimeWorkflowForWebEnabled, isReportTravelTimeWorkflowForNativeEnabled, punchWFFeatureGates, isManageTimeOffAndLeaveEnabled, isViewAttendanceStatusEnabled, requireTaskListAttention }, platform, t) => {
    const isWeb = platform === 'web';
    const isTaskListEnabled = isWeb
        ? isTaskListForWebEnabled
        : isTaskListForNativeEnabled;
    const isPunchWorkflowEnabled = isWeb
        ? isPunchWorkflowForWebEnabled
        : isPunchWorkflowForNativeEnabled;
    const isReportTravelTimeWorkflowEnabled = isWeb
        ? isReportTravelTimeWorkflowForWebEnabled
        : isReportTravelTimeWorkflowForNativeEnabled;
    return [
        {
            label: t('timecard_tiles_attendance_tile_label'),
            eligible: isViewAttendanceStatusEnabled && isAttendanceIngressPointEnabled,
            icon: (react_1.default.createElement(Icons_1.IconBulletedList, { title: "Attendance", color: "primary70", size: Icons_1.IconSize.Large })),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.ATTENDANCE,
            position: TimecardTilesTypes_1.Position.TILE
        },
        {
            label: t('timecard_tiles_timeOff_tile_label'),
            eligible: isManageTimeOffAndLeaveEnabled,
            icon: (react_1.default.createElement(Icons_1.IconBulletedList, { title: "Time Off", size: Icons_1.IconSize.Large, color: "primary70" })),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.TIME_OFF,
            position: TimecardTilesTypes_1.Position.TILE
        },
        {
            label: t('timecard_tiles_tasklist_tile_label'),
            eligible: isTaskListEnabled,
            icon: TaskListIcon(requireTaskListAttention),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.TASK_LIST,
            position: TimecardTilesTypes_1.Position.TILE
        },
        {
            label: t('timecard_tiles_absence_tile_label'),
            eligible: isReportAbsenceLatenessEnabled,
            icon: (react_1.default.createElement(Icons_1.IconCalendar, { title: "Absence", color: "primary70", size: Icons_1.IconSize.Large })),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.ABSENCE,
            position: TimecardTilesTypes_1.Position.TILE
        },
        {
            label: t('timecard_tiles_correct_punches_tile_label'),
            eligible: isPunchWorkflowEnabled &&
                (0, utils_1.isPunchWorkflowEligible)(punchWFFeatureGates, isWeb),
            icon: (react_1.default.createElement(Icons_1.IconBulletedList, { title: "Correct Punches", color: "primary70", size: Icons_1.IconSize.Large })),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.CORRECT_PUNCHES,
            position: TimecardTilesTypes_1.Position.TILE
        },
        {
            label: t('timecard_tiles_report_travel_time_tile_label'),
            eligible: isReportTravelTimeWorkflowEnabled,
            icon: (react_1.default.createElement(Icons_1.IconBulletedList, { title: "Report Travel Time", color: "primary70", size: Icons_1.IconSize.Large })),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.REPORT_TRAVEL_TIME,
            position: TimecardTilesTypes_1.Position.POPOVER
        }
    ];
};
exports.getRedirectTiles = getRedirectTiles;
function TaskListIcon(requireTaskListAttention) {
    return (react_1.default.createElement(react_1.default.Fragment, null, requireTaskListAttention ? (react_1.default.createElement(View_1.View, { style: {
            position: 'relative',
            height: '100%'
        } },
        react_1.default.createElement(Icons_1.IconBulletedList, { style: {
                position: 'absolute',
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }, title: "Tasklist", size: Icons_1.IconSize.Large, color: 'primary70' }),
        react_1.default.createElement(View_1.View, { style: {
                position: 'absolute',
                zIndex: 2,
                top: -23,
                right: -22,
                backgroundColor: '#DA3733',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                width: '16px',
                height: `16px`
            } }))) : (react_1.default.createElement(Icons_1.IconBulletedList, { title: "Tasklist", color: "primary70", size: Icons_1.IconSize.Large }))));
}
